/* eslint-disable @typescript-eslint/no-explicit-any */
import { SOCKETIO_URL } from '@/config';
// import { createStore, useStore } from '@/util/Store';

import { io, Socket } from 'socket.io-client';
import EventEmitter from 'eventemitter3';

import { proxy, useSnapshot } from 'valtio'

export const socketIO={
  conn:null as Socket|null,
}

// 접속한 유저의 정보 관리
class SessionStoreClass extends EventEmitter{
  mUserInfo = {
    type:'',
    user_code:'',
    name:'',
    thumb_url:'',
  }
  get userInfo(){ return this.mUserInfo }
  mClassInfo = {
    teacher_code:'',
    class_code:'',
    name:'',
  }
  get classInfo(){ return this.mClassInfo }

  mStudents:Array<any> =[];
  get classStudents(){ return this.mStudents }

  mScreenLock = false;
  get screenLock(){ return this.mScreenLock}

  mConnected = false;
  get connected(){ return this.mConnected }

  async init( info:any){
    this.removeAllListeners();
    if(socketIO.conn){
      socketIO.conn.disconnect();
    }
    // socketIO연결
    socketIO.conn =   io( SOCKETIO_URL,{
      path: "/sio/",
      transports: ["websocket"],
      query: info,
    });
    socketIO.conn.on("connect", () => {
      this.mConnected = true;
      //console.log('connect',socketIO.conn!.id); // x8WIv7-mJelg7on_ALbx
      this.emit('connect',socketIO.conn);
    });
    socketIO.conn.on("disconnect", () => {
      this.mConnected = true;
      console.log('disconnect',socketIO.conn!.id); // x8WIv7-mJelg7on_ALbx
      this.emit('disconnect',socketIO.conn);
    });

    // socketIO.conn.on("update-thumb",(data:{user_code:string,thumb_url:string})=>{
    //   console.log('update-thumb',data);
    //   //this.emit('heart',data);
    //   if( data.user_code == this.mUserInfo.user_code ){
    //     this.mUserInfo.thumb_url = data.thumb_url;
    //     StudentInfoStore.thumbURL = data.thumb_url;
    //   }else{
    //     this.mStudents.map( (v)=>{
    //       if( v.user_code==data.user_code){
    //         v.thumb_url = data.thumb_url;
    //       }
    //     })
    //   }
    // });
    socketIO.conn.onAny( (eventName:string,arg:any[])=>{
      // console.log( `->socketIO: ${eventName}`,arg);
      this.emit(eventName,arg);
    })
  }
  disconnect(){
    if(socketIO.conn){
      socketIO.conn.disconnect();
      socketIO.conn=null;
    }
  }
  sendMessage( msg:string ){
    if( socketIO.conn ){
      socketIO.conn.emit('notice', {msg} );
    } 
  }

  // 타겟에게 프로필 업데하라고 보냄.
  // sendHeart(){
  //   // console.log("SocketIO->sendToTeacher" )
  //   socketIO.conn?.emit('heart',{user_code:this.mUserInfo.user_code});
  // }

  // sendToAllStudent(_event:string){

  // }

}

// export const SessionStore = createStore<SessionStoreClass>( new SessionStoreClass() )
// export function useSessionStore(){
//   return useStore( SessionStore )
// }

export const SessionStore = proxy<SessionStoreClass>( new SessionStoreClass() )
export function useSessionStore(){
  return useSnapshot( SessionStore )
}